import { PayWith } from './type';

export const PASSWORD_SECRET = '*'.repeat(8);
export const PAYMENT_METHOD_MAPPED = [PayWith.CARD, PayWith.BM];

export const MY_BILLS_PAY = 'my_bills_pay';
export const BOM_INTRO_POPUP = 'bm_intro';
export const MAX_SAVE_CARD_SHOW = 4;
